
















import { computed, defineComponent } from "@vue/composition-api";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "MessageMediaItemStatus",
  components: { BaseSpinner },
  props: {
    attachment: { type: Object as () => MessageAttachment, required: true },
    isAuthor: { type: Boolean, required: true },
  },
  setup(props) {
    const processing = computed(() => props.attachment.file.processingStatus !== "OK");
    const error = computed(() => props.attachment.file.processingStatus === "ERROR");

    return { processing, error };
  },
});
